<template>
  <div class="py-[10px] flex border-b border-osn-grey-03 cursor-pointer
  pc:border-t pc:hover:bg-[#FFDF8D4D]
  mobile:flex-wrap" :class="{ 'bg-[#FFDF8D4D]': spaceInfo.space_id.toString() === routeSid }"
    @click="clickSpace(spaceInfo.space_id)" @mouseenter="hoverSpace(spaceInfo.space_id)" @mouseleave="leaveSpace">
    <div class="pc:w-[34%] pc:pl-[12px] mobile:w-full flex items-center">
      <div class="image-container">
        <!-- Promoted Tags Badge - 手機版在圖片上 -->
        <div v-for="tag in promotedTags" :key="tag.name" class="vr-badge mobile:block pc:hidden">
          <span class="vr-text">{{ tag.name }}</span>
        </div>
        <FavoriteButton class="absolute top-2 left-2 z-10"
                        :space-id="spaceInfo.space_id" />
        <ShareButton compact class="absolute top-2 right-2 z-10 drop-shadow-md"
                     :target="`/space/${spaceInfo.space_id}`"
                     source="card_share"
                     :share-text="spaceInfo.space_name"
                     @click.stop />
        <img class="aspect-[1024/683] pc:rounded-xl mobile:rounded-3xl" :src="picUrl + spaceInfo.photo_url"
          :alt="spaceInfo.photo_description ? spaceInfo.photo_description : spaceInfo.space_name" />
        <!-- AV P2 刀2:檔期三態徽章(可立即預約/可能可用/可詢問);沿用 SpaceCard 配色與 i18n,
             收藏(左上)/分享(右上)已佔角,徽章放圖左下。無 availability 則不顯示。 -->
        <div v-if="availabilityBadge"
             class="absolute bottom-2 left-2 z-10 px-2 py-0.5 rounded-md text-[12px] font-medium"
             :class="availabilityBadge.class">
          {{ $t(availabilityBadge.key) }}
        </div>
      </div>
    </div>
    <div class="pc:w-[66%] mobile:w-full pc:px-[12px] pc:flex pc:flex-col">
      <!--      <h3 class="mobile:mt-[6px] text-osn-grey-01 text-[12px]">{{ spaceInfo.brand_name }}</h3>-->
      <div class="mobile:mb-[4px] text-[14px] font-bold text-osn-dark-grey-00">{{ spaceInfo.space_name }}</div>
      <div class="tag-wrap">

        <ul>
          <li class="usage" v-for="item in spaceInfo.categories[usageCategoryId]">{{ item.name }}
          </li>
          <!--          <li class="type"
              v-for="item in spaceInfo.categories[typeCategoryId]">{{ item.name }}
          </li>
          <li class="tag"
              v-for="item in spaceInfo.categories[tagCategoryId]">{{ item.name }}
          </li>-->
        </ul>
      </div>
      <div class="pc:h-[21px] flex items-center text-[14px]"
        :class="spaceInfo.traffics.length > 0 ? 'mobile:mt-3' : ''">
        <svg-icon v-if="spaceInfo.traffics.length > 0" class="mr-[5px]" name="mrt" size="20"></svg-icon>
        <span v-if="spaceInfo.traffics.length > 0">{{ `${spaceInfo.traffics[0]?.mrt_station}
          ${spaceInfo.traffics[0]?.mrt_exit} 號出口 ` }}</span>
        <span v-if="spaceInfo.traffics.length > 0" class="ml-[3px] text-osn-grey-01">{{
          $t('space.walking_time', { t: spaceInfo.traffics[0]?.walking_time })
          }}</span>
      </div>
      <div class="mt-[4px] flex items-center text-[14px]">
        <svg-icon class="mr-[5px]" name="location" size="20"></svg-icon>
        <span>{{ spaceInfo.city + spaceInfo.region + spaceInfo.address }}</span>
      </div>
      <div class="mt-[4px] px-[8px] flex justify-between items-center">
        <div class="mr-[8px] font-semibold text-[16px]">
          <span class="mr-[5px]">{{ parseFormatCheapestRentPrice(spaceInfo.rent.rent_groups, searchRentType.toString())
          }}</span>
          <span class="font-normal text-osn-grey-01 text-[14px]">{{
            `/${searchRentType !== RentType.DAY ? parseFormatCheapestRentType(spaceInfo.rent.rent_groups) :
              RentTypeUnits[RentType.DAY]}`
            }}</span>
        </div>
        <div class="text-osn-grey-01 text-[14px] inline-flex items-center">
          <svg-icon class="mr-[4px]" name="people" size="16"></svg-icon>
          {{ spaceInfo.number_of_people_max + '人' }}
        </div>
      </div>
      <!-- Promoted Tags Badge - PC 版在這裡 -->
      <div v-if="promotedTags.length > 0" class="pc:mt-auto pc:block mobile:hidden">
        <div v-for="tag in promotedTags" :key="tag.name" class="vr-badge-pc">
          <span class="vr-text">{{ tag.name }}</span>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup>

import { computed, defineProps } from "vue";
import { useRoute, useRouter } from "nuxt/app";
import { useSettingStore } from "~/stores/setting.js";
import { useGoTo } from "@/composables/useGoTo";
import { parseFormatCheapestRentPrice, parseFormatCheapestRentType } from "~/utils/newPriceTool.ts";
import { RentType, RentTypeUnits } from "~/utils/enums/RentType.ts";
import { recordSpaceClick } from "@/api/space";
import ShareButton from "@/components/Share/ShareButton.vue";
import FavoriteButton from "@/components/Favorite/FavoriteButton.vue";
import vrVideoData from '@/config/vrVideo.json';
import { useSearchResultStore } from "~/stores/searchResult";
import { useRemarketing } from "@/composables/useRemarketing";
import { useBehaviorFlow } from "@/composables/useBehaviorFlow";

const router = useRouter()
const route = useRoute();
const settingStore = useSettingStore()
const { goToSpacePage } = useGoTo()

const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL
const typeCategoryId = import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID
const tagCategoryId = import.meta.env.VITE_APP_BASE_TAG_CATEGORY_ID
const usageCategoryId = import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID

const routeSid = computed(() => route.query.msid)
const isMobile = computed(() => settingStore.isMobile);

const props = defineProps({
  spaceInfo: {
    type: Object
  },
  searchRentType: {
    type: Number
  },
  // BI P2:卡片在結果列表中的位置(0-based),來自呼叫端的 v-for index。
  listPosition: {
    type: Number,
    default: undefined
  }
})

const { trackSelectSpace } = useRemarketing()
const behaviorFlow = useBehaviorFlow()

// AV P2 刀2:檔期三態視覺(綠=可立即預約 / 琥珀=可能可用 / 灰=可詢問),與 SpaceCard 一致。
// availability 由 useSearchWithStore.enrichAvailability 疊在搜尋結果上;無值則不顯示徽章。
const availabilityBadge = computed(() => {
  const meta = {
    reservable: { key: 'availability.reservable', class: 'bg-osn-green-1 text-osn-green-4' },
    maybe: { key: 'availability.maybe', class: 'bg-osn-yellow-06 text-osn-yellow-03' },
    inquiry: { key: 'availability.inquiry', class: 'bg-osn-grey-04 text-osn-grey-01' }
  }
  return meta[props.spaceInfo?.availability] || null
})

const promotedTags = computed(() => {
  // 優先使用後端 API 的 promoted_tags
  if (props.spaceInfo.promoted_tags && props.spaceInfo.promoted_tags.length > 0) {
    return props.spaceInfo.promoted_tags
  }
  // Fallback 到 vrVideo.json：如果有 VR 影片，回傳一個模擬的 tag 物件
  const hasVrVideo = vrVideoData.some(item => item.spaceId === props.spaceInfo.space_id)
  if (hasVrVideo) {
    return [{ name: 'VR' }]
  }
  return []
})

function clickSpace(spaceId) {
  // 置頂等付費版位卡片點擊計入計量;fire-and-forget,失敗不影響導頁
  if (props.spaceInfo.promoted_tags?.length > 0) {
    recordSpaceClick(spaceId, 'search').catch(() => { })
  }
  trackSelectSpace({
    spaceId,
    requestId: useSearchResultStore().getRequestId,
    listPosition: props.listPosition,
  })
  // BI-UI v2:implicit feature portal_discovery(implementation.md §5.1)。
  behaviorFlow.trackSelectSpace(String(spaceId), useSearchResultStore().getRequestId, 'search')
  goToSpacePage(spaceId)
}

function hoverSpace(spaceId) {
  if (isMobile.value) {
    return
  }
  router.replace({ query: { ...route.query, 'msid': spaceId } })

}

function leaveSpace() {
  // console.log('Mouse left the space');

}
</script>
<style scoped lang="scss">
.image-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.tag-wrap {
  ul {
    @apply flex flex-wrap;

    li {
      @apply w-auto h-[23px] mr-[2px] mb-[2px] px-[6px] py-[2px] bg-osn-yellow-00 rounded-md;
    }

    li.type {
      @apply bg-osn-yellow-04 text-[11px] py-[4px];
    }

    li.tag {
      @apply bg-osn-yellow-05 text-[11px] py-[4px];
    }

  }
}
</style>
